// extracted by mini-css-extract-plugin
module.exports = {"list":"PaymentInfo_list__3QGIA","item":"PaymentInfo_item__1viWY","item-active":"PaymentInfo_item-active__30iKV"};